import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { isNull } from 'helpers/nullCheck';
import { throwError } from 'rxjs';
import { AuthService } from 'services/auth.service';
import { USE_AUTH } from './tokens';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
	if (!req.context.get(USE_AUTH)) return next(req);

	const auth = inject(AuthService).getAuthInfo();

	if (!auth?.token || !auth?.id) {
		const errorMsg = 'Token ou ID do usuário ausente. A requisição não será autenticada.';

		return throwError(
			() =>
				new HttpErrorResponse({
					status: 401,
					statusText: 'Unauthorized',
					error: errorMsg,
				}),
		);
	}

	let newReq = req.clone({
		headers: req.headers.set('Authorization', `Bearer ${auth.token}`),
	});

	if (isNull(req.params.get('userId'))) {
		newReq = newReq.clone({ params: req.params.append('userId', auth.id) });
	}

	return next(newReq);
};
